export enum FollowUpType {
  None = 0,
  TwoWeeks = 1,
  OneMonth = 2,
  OneAndHalfMonth = 3,
  TwoMonths = 4,
  ThreeMonths = 5,
  SixMonths = 6,
}
